module.exports = __webpack_public_path__ + "27fc17c3a701115a972198602364f2ce.jpg";